// extracted by mini-css-extract-plugin
module.exports = {"container":"AdvisorDisclaimer-module__container--11vFA","header":"AdvisorDisclaimer-module__header--2aNsC","titleStyle":"AdvisorDisclaimer-module__titleStyle--2a8eR"};